import { Box } from '@mui/material';
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import Layout from './Layout';
import AuthHead from './authhead';
import { BtnInput, EmailInput, GoBackBtn } from './inputs';
import { useChangeAuthType } from '@/util/hooks/changeAuth';

export default function Forgotpassword() {
    const {classes}=styles();
    const changeAuthType = useChangeAuthType();
  return (
   <Layout image='/images/explore/explore.svg'>
     <Box className={`${classes.container} `}>
      <AuthHead/>
      <Box className={classes.input}>
       <EmailInput/>
       <BtnInput name="Continue" btnAction={()=>changeAuthType('passwordreset')}/>
       <GoBackBtn name={'Go back to the log in page'} btnAction={()=>changeAuthType('login')}/>
      </Box>
      </Box>
   </Layout>
  )
}

const styles=makeStyles()((theme)=>({
    container:{
    backgroundColor:theme.colors.white,
    display:'flex',
    flexDirection:'column',
   width:'80%'
    },
    input:{
      display:'flex',
      flexDirection:'column',
      gap:theme.spacing(3) 
    }
}))